// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination[data-v-100553b8]{display:inline-block;display:flex;align-items:center;justify-content:flex-end}.pagination .turn[data-v-100553b8]{border-radius:3px;cursor:pointer}.pagination .turn.turnTo[data-v-100553b8]{cursor:no-drop}", ""]);
// Exports
module.exports = exports;
